import React from 'react';
import { connect } from 'react-redux';
import { resetWaitingAreaForm, createWaitingArea as createWaitingAreaAction } from '../../../../actions/waitingArea';
import { forceValidation, clearAllValidationErrors } from '../../../../businessLogic/validation.js';

import { displayGlobalMessage, hideGlobalMessage } from '../../../../actions/globalMessage';
import { hideModal, updateShowCreateWaitingAreaModal } from '../../../../actions/modal';

@connect(mapStateToProps)
export default class RightPanelCreate extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  createWaitingArea = () => {
    let areThereErrors = forceValidation(undefined, undefined, 'createWaitingArea');
    if (!areThereErrors) {
      let cb = () => {
        let show = false;
        this.props.dispatch(updateShowCreateWaitingAreaModal(show));
        setTimeout(() => {
          this.resetForm();
        }, 200); //timeout waiting for the hide effect to finish
      };
      this.props.dispatch(createWaitingAreaAction(this.props.waitingAreaForm, cb));
    }
  };

  cancelCreateWaitingArea = () => {
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) this.props.dispatch(hideGlobalMessage());
    let show = false;
    this.props.dispatch(updateShowCreateWaitingAreaModal(show));
    setTimeout(() => {
      this.resetForm();
    }, 200); //timeout waiting for the hide effect to finish
  };

  componentDidMount() {
    this.resetForm();
  }

  resetForm = () => {
    this.props.dispatch(resetWaitingAreaForm());
  };

  render() {
    let saveClasses =
      'ui disable labeled icon mrtm button icon color-button color-button-hover color-white  max-width left-text mrlnull mrbnull';
    return (
      <div className="ui actions mrbl max-width ">
        <button
          type="button"
          tabIndex="3"
          onClick={this.createWaitingArea}
          data-group="createWaitingArea"
          className={this.props.fetchingWaitingAreas ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Create}
          <i className="add  icon" />
        </button>
        <button
          type="button"
          tabIndex="6"
          onClick={this.cancelCreateWaitingArea}
          className="ui labeled icon button color-bad-things color-bad-things-hover color-white    mrtm max-width left-text mrlnull mrbnull"
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    waitingAreaForm: state.waitingAreaReducer.waitingAreaForm,
    fetchingWaitingAreas: state.waitingAreaReducer.fetchingWaitingAreas,
  };
}
